export default __webpack_public_path__ + "static/media/uw1.7f647c16.png";